module.exports = __webpack_public_path__ + "media/images/redesign-images/ffa/design-tile-images/design-tile-11-c850880b0d41ad35a846e5043e762ce4.webp";